
const CLICK_MAGICK_CONFIG_ID = 'clickmagick-cmc-config'
const CLICK_MAGICK_SCRIPT_ID = 'clickmagick-cmc-script'

/**
 * The official ClickMagick TrueTracking configuration, character for character
 * as supplied by ClickMagick. It is injected into the document head as a real
 * inline <script> element so the full configuration is visible in the rendered
 * page when inspecting the DOM.
 */
const CLICK_MAGICK_CONFIG_CODE = `    window.clickmagick_cmc = {
        uid: '213029',
        hid: '1629707996',
        cmc_project: 'Proyecto Joint Genesis',
        vid_info: 'on',
        utm_source: 'organic',
    }
`

declare global {
  interface Window {
    clickmagick_cmc?: {
      uid: string
      hid: string
      cmc_project: string
      vid_info: 'on' | 'off'
      utm_source: string
    }
  }
}

/**
 * Installs the ClickMagick TrueTracking code once for the current visitor:
 * the inline configuration block followed by the external loader.
 */
export function initClickMagick(): void {
  if (typeof window === 'undefined') return
  if (document.getElementById(CLICK_MAGICK_CONFIG_ID)) return

  const configScript = document.createElement('script')
  configScript.id = CLICK_MAGICK_CONFIG_ID
  configScript.text = CLICK_MAGICK_CONFIG_CODE
  document.head.appendChild(configScript)

  if (!document.getElementById(CLICK_MAGICK_SCRIPT_ID)) {
    const loaderScript = document.createElement('script')
    loaderScript.id = CLICK_MAGICK_SCRIPT_ID
    loaderScript.src = '//track.jointgenesis369.com/affe6e82.js'
    document.head.appendChild(loaderScript)
  }
}

/**
 * Destination for the final CTA. ClickMagick registers the action and then
 * handles the redirect to the vendor via its own cmc_redir parameter.
 */
export const OFFER_URL =
  'https://jointgenesis369.com?cmc_goal=a&cmc_ref=sawoffer&cmc_redir=https%3A%2F%2F533e6fn7n1cy9rdhzbpph3yze8.hop.clickbank.net%3Ftid%3D%5Bcmc_vid%5D'
